//Viewport
if(navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('iPod') > 0 || (navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0)){
  $('head').prepend('<meta name="viewport" content="width=device-width, user-scalable=no, initial-scale=1, minimum-scale=1, maximum-scale=1, viewport-fit=cover">');
}else if(navigator.userAgent.indexOf('iPad') > 0 || (navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') == -1) || navigator.userAgent.indexOf('A1_07') > 0 || navigator.userAgent.indexOf('SC-01C') > 0){
  $('head').prepend('<meta name="viewport" content="width=1120px">');
}

jQuery(document).ready(function(){
  //NavigationControl
  var toggle = $('#nav-toggler'),
      dropdown = $('#nav-list');
  $(window).on('resize', function(){
    if(toggle.css('display') == 'none'){
      toggle.removeClass('active');
      dropdown.removeAttr('style').find('a').removeClass('anima');
    }
  });
  toggle.on('click', function(){
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
      dropdown.stop().slideDown(300, 'easeInOutQuart', function(){
        $(this).find('a').each(function(i){
          $(this).delay(120*i).queue(function(){ $(this).stop().addClass('anima');});
        });
      });
    }else{
      dropdown.stop().slideUp(300, 'easeInOutQuart', function(){
        $(this).find('a').removeClass('anima');
      });
    }
  });

  //Fix Scroll
  $(window).on('scroll', function(){
    if(toggle.css('display') == 'none'){
      document.getElementById('header').style.left = -window.scrollX + 'px';
      document.getElementById('footer').style.left = -window.scrollX + 'px';
    }
  });

  //Scroll
  var headerh = $('#nav h1'),
      totop = $('#footer-totop');
  $(window).on('scroll', function(){
    //Fix
    if(toggle.css('display') == 'none'){
      document.getElementById('nav').style.left = -window.scrollX + 'px';
    }
    //Header & Totop
    if($(this).scrollTop() > 600){
      headerh.addClass('active');
      totop.addClass('active');
    }else{
      headerh.removeClass('active');
      totop.removeClass('active');
    }
  });
  totop.on('click', function(){
    $('html, body').stop().animate({scrollTop: 0}, 600, 'easeInOutQuad');
    return false;
  });

  //Rellax
  if($('#subintro').length){
    var subintroRx = new Rellax('#subintro-img', {speed: -3});
  }
  if($('.about').length){
    var aboutRx = new Rellax('.about-img figure', {speed: -1, center: true});
  }
  if($('.list').length){
    var listRx = new Rellax('.list-img', {speed: 1, center: true});
    var ListSsRx = new Rellax('.list-square-s', {speed: 1, center: true});
    var ListSmRx = new Rellax('.list-square-m', {speed: 2, center: true});
    var ListSlRx = new Rellax('.list-square-l', {speed: 4, center: true});
  }
  if($('.report').length){
    var reportRx = new Rellax('.report-item-img figure', {speed: -1, center: true});
  }
  if($('.feature').length){
    var featureRx = new Rellax('.feature-item-area-header figure', {speed: -1, center: true});
  }
  if($('#step').length){
    var stepRx = new Rellax('#step-img figure', {speed: -3, center: true});
  }
  if($('#faq').length){
    var faqRx = new Rellax('#faq-img', {speed: -3, center: true});
  }
  if($('#contact').length){
    var contactRx = new Rellax('#contact-img', {speed: -3, center: true});
  }
  if($('#challenge-img').length){
    var challenge1Rx = new Rellax('#challenge-img-1', {speed: 4, center: true});
    var challenge2Rx = new Rellax('#challenge-img-2', {speed: 2, center: true});
  }

  //Swiper
  if($('#intro-slider').length){
    var sliderThumbs, sliderMain;
    sliderThumbs = new Swiper('#intro-slider-thumbs', {
      slidesPerView: 4,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });
    sliderMain = new Swiper('#intro-slider-main', {
      speed: 600,
      slidesPerView: 1,
      grabCursor: true,
      autoplay: {
        delay: 3600,
        disableOnInteraction: false
      },
      thumbs: {
        swiper: sliderThumbs
      }
    });
  }
  if($('#develop-content-slider').length){
    var sliderGraph;
    sliderGraph = new Swiper('#develop-content-slider', {
      speed: 600,
      slidesPerView: 'auto',
      grabCursor: true,
      centeredSlides: true,
      autoplay: {
        delay: 3600
      },
      pagination: {
        el: '#develop-content-slider-pagination',
      }
    });
  }
  if($('#flow-slider').length){
    var flowGraph;
    flowGraph = new Swiper('#flow-slider', {
      speed: 600,
      slidesPerView: 1,
      grabCursor: true,
      autoplay: {
        delay: 3600
      },
      pagination: {
        el: '#flow-slider-pagination',
      }
    });
  }


  //Inview
  var i;
  $('#intro, #subintro, .about, .list-content, #develop-content-slider, .balloon-item-content').on('inview', function(event, isInView, visiblePartX, visiblePartY){
    if(isInView){ $(this).addClass('anima');}
  });
  $('.report').on('inview', function(event, isInView, visiblePartX, visiblePartY){
    if(isInView){
      i = 0;
      $(this).find('.report-item').each(function(i){
        $(this).delay(180*i).queue(function(){ $(this).stop().addClass('anima');});
      });
    }
  });
  $('.contact').on('inview', function(event, isInView, visiblePartX, visiblePartY){
    if(isInView){
      i = 0;
      $(this).find('.contact-item').each(function(i){
        $(this).delay(180*i).queue(function(){ $(this).stop().addClass('anima');});
      });
    }
  });
  $('.feature').on('inview', function(event, isInView, visiblePartX, visiblePartY){
    if(isInView){
      i = 0;
      $(this).find('.feature-item').each(function(i){
        $(this).delay(180*i).queue(function(){ $(this).stop().addClass('anima');});
      });
    }
  });
  $('.step').on('inview', function(event, isInView, visiblePartX, visiblePartY){
    if(isInView){
      i = 0;
      $(this).find('.step-item').each(function(i){
        $(this).delay(180*i).queue(function(){ $(this).stop().addClass('anima');});
      });
    }
  });
  $('.flow').on('inview', function(event, isInView, visiblePartX, visiblePartY){
    if(isInView){
      i = 0;
      $(this).find('.flow-item').each(function(i){
        $(this).delay(180*i).queue(function(){ $(this).stop().addClass('anima');});
      });
    }
  });
  $('.table').on('inview', function(event, isInView, visiblePartX, visiblePartY){
    if(isInView){
      i = 0;
      $(this).find('.table-item').each(function(i){
        $(this).delay(180*i).queue(function(){ $(this).stop().addClass('anima');});
      });
    }
  });
  $('.faq').on('inview', function(event, isInView, visiblePartX, visiblePartY){
    if(isInView){
      i = 0;
      $(this).find('.faq-item').each(function(i){
        $(this).delay(180*i).queue(function(){ $(this).stop().addClass('anima');});
      });
    }
  });
});
